module.exports = __webpack_public_path__ + "img/rad-dig-sala-config-1.028df736.png";